import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { CategoryID } from '@sbt-web/network/types';
import SafetyTips from '../../SafetyTips';
import { SectionProps } from './section';
type Props = SectionProps & {
  category: CategoryID;
  urn: string;
};
export function SafetySection(t0) {
  const $ = _c(10);
  const {
    classes: t1,
    category,
    urn
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classes = t2;
  let t3;
  if ($[2] !== classes) {
    t3 = classnames(...classes, "safety-component");
    $[2] = classes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== category || $[5] !== urn) {
    t4 = <SafetyTips category={category} adUrn={urn} />;
    $[4] = category;
    $[5] = urn;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <section className={t3}>{t4}</section>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
export default SafetySection;